module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {
	'use strict';

	fox.registerWidget('Profile_Submit', {
		configure: function() {
			this.data = {approvalState: 0};

			this.registerOptions('', {
				autoRender: true,
				container: '.submit-block',
				template: 'profile_submit',

				widgets: {
					approvalState: {
						widget: 'Api',
						method: 'studio.model.getProfileApprovalState'
					},

					submit: {
						widget: 'Api',
						method: 'studio.model.submitProfile'
					}
				},

				handleWom: {
					/*submit: {
						widget: '#submit',
						event: ['success', 'error', 'failure', 'prepare'],
						callback: '_handleSubmit'
					},*/
					handleApprovalState: {
						widget: '#approvalState',
						event: ['success'/*, 'error', 'failure', 'prepare'*/],
						callback: '_handleApprovalState'
					},
					submitted: {
						widget: '@this',
						event: "submitted",
						callback: 'getApprovalState'
					}
				}
			});

			this.callParent('configure', arguments);
		},

		init: function (argument) {
			this.apiInProgress = false;

			this.callParent('init', arguments);
		},

		deactivate: function (argument) {
			this.apiInProgress = false;
			this.setBlockState(0);
			this.callParent('deactivate', arguments);
		},

		_handleSubmit: function (data, api, e) {
			if (e === 'prepare') {
				this.toggleLoader(true);

				return;
			}

			this.toggleLoader(false);
			this.apiInProgress = false;

			if (fox.inArray(['error', 'failure'], e)) {
				console.error('Something went wrong!!!', data, api, e);
				this.dispatchEvent('submitted.error');
				return;
			}

			this.dispatchEvent('submitted');
		},

		_handleApprovalState: function (data, api, e) {
			if (e !== 'success') {
				console.warn('error with getting approve state');
				return;
			}

			this.data = data.answer.response;

			this.setBlockState(this.data.approvalState);
			this.dispatchEvent('stateLoaded', {state: this.data.approvalState});
		},

		getApprovalState: function () {
			var api = this.wom1('#approvalState');

			if (!api) return;

			return api.psend(this.modelId ? {id: this.modelId} : {});
		},

		submit: function () {
			if (this.apiInProgress === true) {
				return;
			}

			var api = this.wom1('#submit');

			if (!api) {
				return;
			}

			api.psend({id: this.modelId}).then(function (resp) {
				this.apiInProgress = true;

				return this._handleSubmit(resp.params, resp.performer, resp.event);
			}.bind(this)).catch(function (resp) {
				return this._handleSubmit(resp.params, resp.performer, resp.event);
			});
		},

		setBlockState: function (state) {
			this.setApprovalState(state);

			this.setTemplateOptions({
				state: this.data.approvalState,
				submitDate: this.data.submitDate,
				approvalDate: this.data.approvalDate
			});

			this.render();
		},

		setModelId: function (id) {
			this.modelId = id;
		},

		getState: function (argument) {
			return this.data.approvalState;
		},

		getComments: function (argument) {
			return this.data.comments;
		},

		getFields: function (argument) {
			var obj = {
				disapproved: [],
				approved: []
			};

			fox.each(this.data.submitState, function (state, name) {
				if (!state) {
					obj.disapproved.push(name);

					return;
				}

				obj.approved.push(name);
			}, this);

			return obj;
		},

		getCommentsByFieldName: function (name) {
			if (!this.data.comments) {
				return false;
			}
			
			return this.data.comments[name] || false;
		},

		setApprovalState: function (state) {
			if(fox.getEnv('isLegalApproveRequired') === 1 && state === 2) state = 0;
			this.data.approvalState = state || 0;

			return this;
		},

		toggleLoader: function (show) {
			var el = this.dom1('.button-with-spinner');

			if (!el) {
				return;
			}

			fox.dom[(show === true ? 'addClass' : 'removeClass')]('spin', el);
		}

	}, 'Widget');
})(fox);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/widget/sitepage/profile/submit.js
// module id = 354
// module chunks = 2